exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slick-prev:before,\n.slick-next:before {\n  color: black;\n}\n", ""]);

// exports
